import { useEffect, useState } from 'react';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from '@heroui/react';
import type { TipoPedido } from '@/types/tipo-pedido.model';

interface DeleteTipoPedidoModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: (id: string | number) => Promise<void>;
  tipoPedido?: TipoPedido;
}

const DeleteTipoPedidoModal = ({ isOpen, onClose, onDelete, tipoPedido }: DeleteTipoPedidoModalProps) => {
  const [itemToDelete, setItemToDelete] = useState<TipoPedido | undefined>(undefined);

  // Populate form when tipoPedido changes
  useEffect(() => {
    if (tipoPedido) {
      setItemToDelete(tipoPedido);
    } else {
      setItemToDelete(undefined);
    }
  }, [tipoPedido]);

  const handleDelete = async () => {
    if (itemToDelete?.id) {
      await onDelete(itemToDelete.id);
      onClose();
    }
  };

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose}
      placement="top-center"
      backdrop="blur"
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className="flex flex-col gap-1">Eliminar Tipo de Pedido</ModalHeader>
            <ModalBody>
              <p>¿Estás seguro de que deseas eliminar el tipo de pedido <strong>{itemToDelete?.nombre}</strong>?</p>
              <p className="text-danger">Esta acción no se puede deshacer.</p>
            </ModalBody>
            <ModalFooter>
              <Button 
                color="danger" 
                variant="light" 
                onPress={onClose}
              >
                Cancelar
              </Button>
              <Button 
                color="primary" 
                onPress={handleDelete}
              >
                Eliminar
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};

export default DeleteTipoPedidoModal;